import { render, staticRenderFns } from "./VcardTextAjustHeight.vue?vue&type=template&id=37cc8818&scoped=true"
import script from "./VcardTextAjustHeight.vue?vue&type=script&lang=ts"
export * from "./VcardTextAjustHeight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cc8818",
  null
  
)

export default component.exports